export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/backing',
    name: '/backing',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/backing.vue'),
    /* no children */
  },
  {
    path: '/batteries',
    name: '/batteries',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/batteries.vue'),
    /* no children */
  },
  {
    path: '/cessions',
    name: '/cessions',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/cessions.vue'),
    /* no children */
  },
  {
    path: '/cessions/:cessionId/financings/:financingId',
    name: '/cessions.[cessionId].financings.[financingId]',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/cessions.[cessionId].financings.[financingId].vue'),
    /* no children */
  },
  {
    path: '/cessions/:id',
    name: '/cessions.[id]',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/cessions.[id].vue'),
    /* no children */
  },
  {
    path: '/cessions/create',
    name: '/cessions.create',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/cessions.create.vue'),
    /* no children */
  },
  {
    path: '/financing-blocklist',
    name: '/financing-blocklist',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/financing-blocklist.vue'),
    /* no children */
  },
  {
    path: '/financing/:id',
    name: '/financing.[id]',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/financing.[id].vue'),
    /* no children */
  },
  {
    path: '/financings',
    name: '/financings',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/financings.vue'),
    /* no children */
  },
  {
    path: '/inactive-accounts',
    name: '/inactive-accounts',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/inactive-accounts.vue'),
    /* no children */
  },
  {
    path: '/incentive-detail',
    name: '/incentive-detail',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/incentive-detail.vue'),
    /* no children */
  },
  {
    path: '/incentive-new',
    name: '/incentive-new',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/incentive-new.vue'),
    /* no children */
  },
  {
    path: '/incentives',
    name: '/incentives',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/incentives.vue'),
    /* no children */
  },
  {
    path: '/inverters',
    name: '/inverters',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/inverters.vue'),
    /* no children */
  },
  {
    path: '/microInverters',
    name: '/microInverters',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/microInverters.vue'),
    /* no children */
  },
  {
    path: '/modules',
    name: '/modules',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/modules.vue'),
    /* no children */
  },
  {
    path: '/partner/:id',
    name: '/partner.[id]',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/partner.[id].vue'),
    /* no children */
  },
  {
    path: '/partners',
    name: '/partners',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/partners.vue'),
    /* no children */
  },
  {
    path: '/profile',
    name: '/profile',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/profile.vue'),
    /* no children */
  },
  {
    path: '/revalida-campaign-detail',
    name: '/revalida-campaign-detail',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/revalida-campaign-detail.vue'),
    /* no children */
  },
  {
    path: '/revalida-campaign-new',
    name: '/revalida-campaign-new',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/revalida-campaign-new.vue'),
    /* no children */
  },
  {
    path: '/revalida-campaigns',
    name: '/revalida-campaigns',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/revalida-campaigns.vue'),
    /* no children */
  },
  {
    path: '/revalida-partner-view',
    name: '/revalida-partner-view',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/revalida-partner-view.vue'),
    /* no children */
  },
  {
    path: '/revalida-partner-view/:id',
    name: '/revalida-partner-view.[id]',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/revalida-partner-view.[id].vue'),
    /* no children */
  },
  {
    path: '/ruleEngine',
    name: '/ruleEngine',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/ruleEngine.vue'),
    /* no children */
  },
  {
    path: '/ruleRisk',
    name: '/ruleRisk',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/ruleRisk.vue'),
    /* no children */
  },
  {
    path: '/settings',
    name: '/settings',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/settings.vue'),
    /* no children */
  },
  {
    path: '/unauthorized',
    name: '/unauthorized',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/unauthorized.vue'),
    /* no children */
  },
  {
    path: '/users',
    name: '/users',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/users.vue'),
    /* no children */
  },
  {
    path: '/users/:id',
    name: '/users.[id]',
    component: () => import('/home/runner/_work/fc.ext.fintech-backoffice/fc.ext.fintech-backoffice/src/pages/users.[id].vue'),
    /* no children */
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

